import React, {useState, useContext, useEffect, useMemo} from 'react';
import {Context} from '../../../Helpers/Auth';
import {useHistory} from 'react-router-dom';
import {useTranslation} from 'react-i18next';
import i18n from '../../../i18n';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import FiltrosTarefas from './FiltrosTarefas';
import {format, addDays, subDays, isMonday, isToday, getDay, parseISO, startOfWeek, intervalToDuration, isWithinInterval, isBefore, differenceInMinutes} from 'date-fns';
import {pt, enUS, fr} from 'date-fns/locale';
import {DragDropContext, Droppable, Draggable} from 'react-beautiful-dnd';
import Tarefa from './Tarefa';
import Theme from '../../Theme';
import {getReunioes, postUpdateVisita, getRepresentantes} from '../../../pages/requests';

import ProfileFoto from '../../../assets/images/profile-user.png';
import {toast} from 'react-toastify';
import ReportTable from './ReportTable';

function Calendario({
    nomeTarefa,
    representantes,
    mostraFiltro,
    mostraTarefa,
    setRepresentanteFiltro,
    representanteFiltro,
    categoriaFiltro,
    setCategoriaFiltro,
    setEditarAgendamentos,
    onRowClick,
    filtroDescricao,
}) {
    const history = useHistory();
    const {utilizador, theme, rep, userRepresentante} = useContext(Context);
    const [dataAtual, setDataAtual] = useState(new Date());
    const [diaDeHoje, setDiaDeHoje] = useState(new Date());
    const [dia, setDia] = useState([]);
    const [fimSemana, setFimSemana] = useState(false);
    const [outraSemana, setOutraSemana] = useState(false);
    const [colCalendario, setColCalendario] = useState();
    const [reunioesVisita, setReunioesVisita] = useState([]);
    const [categorias, setCategorias] = useState('');
    const [representante, setRepresentante] = useState(userRepresentante);
    // const [representantes, setRepresentantes] = useState([]);
    const [selectedWeek, setSelectedWeek] = useState('');
    const [droppableData, setdroppableData] = useState('');
    const [showFilters, setShowFilters] = useState(false);
    const [reunioesSemana, setReunioesSemana] = useState([]);
    const [temposPlaneado, setTemposPlaneado] = useState([]);

    const [diasDaSemanaComDatas, setDiasDaSemanaComDatas] = useState([]);

    const [listaRepresentantes, setListaRepresentantes] = useState([]);

    const handleWeekChange = event => {
        setSelectedWeek(event.target.value);
    };

    const parseYearAndWeek = selectedWeek => {
        const [year, week] = selectedWeek.split('-W').map(Number);
        return {year, week};
    };

    const {t} = useTranslation();

    const idiomaAtual = localStorage.getItem('i18nextLng');
    let locale;
    if (idiomaAtual == 'pt') {
        locale = pt;
    } else if (idiomaAtual == 'fr') {
        locale = fr;
    } else if (idiomaAtual == 'en') {
        locale = enUS;
    }

    let lang;
    if (idiomaAtual == 'pt') {
        lang = 'POR';
    } else if (idiomaAtual == 'fr') {
        lang = 'FRA';
    } else if (idiomaAtual == 'en') {
        lang = 'EN';
    } else if (idiomaAtual == 'es') {
        lang = 'ES';
    }

    const diadeHojeFormat = format(diaDeHoje, 'E dd/MM', {locale});

    useEffect(() => {
        if (selectedWeek) {
            const {year, week} = parseYearAndWeek(selectedWeek);
            const adjustedWeek = week + 1;
            const isoDateString = `${year}-W${String(adjustedWeek).padStart(2, '0')}-1`;
            const startOfWeekDate = startOfWeek(parseISO(isoDateString));

            setDataAtual(startOfWeekDate);
        }
    }, [selectedWeek]);

    // useEffect(() => {
    //     getRepresentantes(lang).then(res => {
    //         setRepresentantes(res.data.representantes);
    //     });
    // }, []);

    useEffect(() => {
        if (!utilizador) {
            return;
        }

        getReunioes(utilizador).then(function (response) {
            var comps1 = [];
            response.data.reunioes.forEach(element => {
                //Hora Inicio
                const horaI = element.horaInicio;
                var horaIFinal = '';
                if (horaI.length === 4) {
                    horaIFinal = `${horaI.slice(0, 2)}:${horaI.slice(2)}`;
                } else {
                    horaIFinal = horaI;
                }
                //Hora Fim
                const horaF = element.horaFim;
                var horaFFinal = '';
                if (horaF.length === 4) {
                    horaFFinal = `${horaF.slice(0, 2)}:${horaF.slice(2)}`;
                } else {
                    horaFFinal = horaF;
                }
                //Data Inicio
                const anoI = element.dataInicio.slice(6, 10);
                const mesI = element.dataInicio.slice(3, 5);
                const diaI = element.dataInicio.slice(0, 2);
                //Data Fim
                const anoF = element.dataFim.slice(6, 10);
                const mesF = element.dataFim.slice(3, 5);
                const diaF = element.dataFim.slice(0, 2);

                //Start
                const startF = anoI + '-' + mesI + '-' + diaI + 'T' + horaIFinal;
                const endF = anoF + '-' + mesF + '-' + diaF + 'T' + horaFFinal;

                const reunioesF = {
                    title: element.descrição,
                    start: startF,
                    end: endF,
                    color: element.corCategoria,
                    id: element.id,
                    dataI: diaI + '/' + mesI + '/' + anoI + ' ' + horaIFinal,
                    dataF: diaF + '/' + mesF + '/' + anoF + ' ' + horaFFinal,
                    resp: element.responsavel,
                    neg: element.num,
                    cliente: element.cliente,
                    estab: element.estabelecimento,
                    estabid: element.estabelecimentoID,
                    telemovel: element.telemovel,
                    categoria: element.categoria,
                };
                comps1.push(reunioesF);
            });
            setReunioesVisita(comps1);
        });
    }, [utilizador]);

    const handleToggleChange = () => {
        setFimSemana(!fimSemana);
    };

    const calcularDiasDaSemana = () => {
        const diasComDatas = [{dataFormata: '', data: ''}];
        let dataDeInicio = dataAtual;
        while (!isMonday(dataDeInicio)) {
            dataDeInicio = subDays(dataDeInicio, 1);
        }
        const diasNaSemana = fimSemana ? 7 : 5;

        for (let i = 0; i < diasNaSemana; i++) {
            const dataDoDia = addDays(dataDeInicio, i);
            const diaDaSemanaAbreviado = format(dataDoDia, 'E', {locale})[0].toUpperCase() + format(dataDoDia, 'E', {locale}).slice(1);
            const dataFormatada = format(dataDoDia, 'dd/MM');

            diasComDatas.push({
                dataFormata: diaDaSemanaAbreviado + ' ' + dataFormatada,
                data: dataDoDia,
            });
        }

        return diasComDatas;
    };

    const retrocederUmaSemana = () => {
        const novaData = subDays(dataAtual, 7);
        setDataAtual(novaData);
    };

    const avancarUmaSemana = () => {
        const novaData = addDays(dataAtual, 7);
        setDataAtual(novaData);
    };

    const voltarParaSemanaAtual = () => {
        setSelectedWeek('');
        setDataAtual(new Date());
    };

    useEffect(() => {
        if (dataAtual.getDate() + '/' + dataAtual.getMonth() != diaDeHoje.getDate() + '/' + diaDeHoje.getMonth()) {
            setOutraSemana(true);
        } else {
            setOutraSemana(false);
        }
        setDiasDaSemanaComDatas(calcularDiasDaSemana());
    }, [dataAtual, fimSemana]);

    const handleDragEnd = result => {
        if (!result.destination) {
            return;
        }

        const taskId = result.draggableId;
        const newPosition = result.destination.droppableId;

        var diaEscolhido = newPosition.split('/')[0];
        var representanteEscolhido = newPosition.split('/')[1];

        // const guardarConclusaoWS = new Promise((resolve, reject) => {
        postUpdateVisita(taskId, representanteEscolhido, lang, encodeURI(diaEscolhido)).then(function (response) {
            // debugger;

            if (response.data.success) {
                var index = reunioesVisita.findIndex(e => e.id == taskId);
                var reuniao = reunioesVisita.find(e => e.id == taskId);

                const horaInicio = reuniao.dataI.substring(11);
                const horaFim = reuniao.dataF.substring(11);

                reuniao.start = new Date(response.data.newStartDate).setHours(horaInicio.substring(0, 2), horaInicio.substring(3));
                reuniao.end = new Date(response.data.newEndDate).setHours(horaFim.substring(0, 2), horaFim.substring(3));

                reuniao.resp = representanteEscolhido;

                let reunioesVisitaTemp = Object.assign([], reunioesVisita);

                reunioesVisitaTemp.splice(index, 1, reuniao);
                setReunioesVisita(reunioesVisitaTemp);
                setdroppableData(response.data);

                // resolve('Sucesso!');
            } else {
                let mensagem = response.data.errorMessages;
                let resposta = '';
                if (mensagem) resposta = mensagem;
                if (!mensagem) resposta = t('toastErro');
                // reject(resposta);
            }
        });
        // });

        // toast.promise(
        //     guardarConclusaoWS,
        //     {
        //         pending: t('a_guardar'),
        //         success: {
        //             render({data}) {
        //                 return t('reuniaoAlterada');
        //             },
        //         },
        //         error: {
        //             render({data}) {
        //                 return data;
        //             },
        //         },
        //     },
        //     {autoClose: 6000},
        // );
    };

    function checkMachDay(e, diaSemana, representante) {
        var DataInicio = new Date(e?.start);

        DataInicio.setHours('00');
        DataInicio.setMinutes('00');
        DataInicio.setSeconds('00');

        var DataFim = new Date(e?.end);
        DataFim.setMinutes('00');
        DataFim.setHours('01');
        DataFim.setSeconds('00');

        diaSemana.data.setHours('00');
        diaSemana.data.setMinutes('00');
        diaSemana.data.setSeconds('00');

        if (new Date(e.start)?.toString() == 'Invalid Date' || new Date(e.end)?.toString() == 'Invalid Date' || diaSemana.data?.toString() == 'Invalid Date' || isBefore(DataFim, DataInicio)) {
            return false;
        }

        const liveNow = isWithinInterval(diaSemana?.data, {
            start: DataInicio,
            end: DataFim,
        });

        if (e.resp == representante.value && liveNow) {
            return true;
        } else {
            return false;
        }
    }

    function ligthDarkBg() {
        if (theme == 'dark') {
            return '#1f2937';
        } else {
            return '#f3f4f6';
        }
    }

    const getListStyle = isDraggingOver => {
        return {
            backgroundColor: isDraggingOver ? '#fff' : ligthDarkBg(),

            // border: isDraggingOver && `1px dashed blue `,
            maxHeight: '140px',
            minHeight: '140px',
            // height: "180px",
            // borderRadius: 10,
            // margin: 20,
            // width: 272,
            overflowY: 'scroll',
            borderWidth: '1px',
            borderColor: theme == 'dark' ? '#374151' : '#fff',
        };
    };

    useEffect(() => {
        const diasNaSemana = fimSemana ? 7 : 5;
        setColCalendario(diasNaSemana * 2 + 1);
    }, [fimSemana]);

    // FILTRO REPRESENTANTE
    useEffect(() => {
        setListaRepresentantes([]);
        setListaRepresentantes(representanteFiltro?.length != 0 ? representanteFiltro : representantes);
    }, [representanteFiltro, listaRepresentantes, representantes]);

    // FILTRO CATEGORIA
    function handleFiltroCategoria(reuniaoVisita, index) {
        if (filtroDescricao != '' && filtroDescricao != null) {
            const filteredReunioesDesc = filtroDescricao === reuniaoVisita.descrição;
            if (filteredReunioesDesc?.length > 0) {
                return <Tarefa key={index} data={reuniaoVisita} setEditarAgendamentos={setEditarAgendamentos} onRowClick={onRowClick}></Tarefa>;
            }
        }

        if (categoriaFiltro?.length == 0) {
            return <Tarefa key={index} data={reuniaoVisita} setEditarAgendamentos={setEditarAgendamentos} onRowClick={onRowClick}></Tarefa>;
        } else {
            const filteredReunioes = categoriaFiltro.filter(e => e.value === reuniaoVisita.categoria);

            if (filteredReunioes?.length > 0) {
                return <Tarefa key={index} data={reuniaoVisita} setEditarAgendamentos={setEditarAgendamentos} onRowClick={onRowClick}></Tarefa>;
            }
        }
    }

    useEffect(() => {
        handleHorasPlaneadas();
    }, [reunioesVisita, diasDaSemanaComDatas]);

    function handleHorasPlaneadas() {
        var reuniaoTMP = [];
        reunioesVisita.forEach(reuniao => {
            var dataF = new Date(reuniao.end);
            var dataI = new Date(reuniao.start);

            var dataIHoras = new Date(reuniao.start);
            var dataFHoras = new Date(reuniao.end);
            dataIHoras.setFullYear(2020, 10, 3);
            dataFHoras.setFullYear(2020, 10, 3);

            dataF.setHours('00');
            dataF.setMinutes('00');
            dataF.setSeconds('00');

            dataI.setHours('00');
            dataI.setSeconds('00');
            dataI.setMinutes('00');
            let dataAtual = dataF;

            while (isBefore(subDays(dataI, 1), dataAtual)) {
                var diffMinutes = differenceInMinutes(dataFHoras, dataIHoras);

                if (dataF.toString() != dataAtual.toString()) {
                    diffMinutes = 480;
                }

                if (
                    reuniaoTMP.find(e => {
                        e.data.setHours('00');
                        e.data.setMinutes('00');
                        e.data.setSeconds('00');
                        return e.resp == reuniao.resp && e.data.toString() == dataAtual.toString();
                    }) == null
                ) {
                    reuniaoTMP.push({
                        resp: reuniao.resp,
                        data: dataAtual,
                        Total: diffMinutes,
                    });
                } else {
                    var TempoDia = reuniaoTMP.find(e => e.resp == reuniao.resp && e.data.toString() == dataAtual.toString());
                    TempoDia.Total = TempoDia.Total + diffMinutes;
                    var Indice = reuniaoTMP.findIndex(e => e.resp == reuniao.resp && e.data.toString() == dataAtual.toString());
                    reuniaoTMP.splice(Indice, 1, TempoDia);
                }
                dataAtual = subDays(dataAtual, 1);
            }
        });
        setTemposPlaneado(reuniaoTMP);
    }

    function timeConvert(n) {
        if (n == null) {
            return '0h 0mm';
        }
        var num = n;
        var hours = num / 60;
        var rhours = Math.floor(hours);
        var minutes = (hours - rhours) * 60;
        var rminutes = Math.round(minutes);
        return rhours + 'h ' + rminutes + 'mm';
    }

    function temposPlaneados(representante, dia) {
        var planeado;
        var data = dia?.data;
        data?.setMinutes('00');
        data?.setHours('00');
        data?.setSeconds('00');
        planeado = temposPlaneado?.find(e => e?.data?.toString() == data?.toString() && e?.resp == representante.value);

        return (
            <div className="flex items-center font-medium justify-center dark:text-gray-400 text-gray-500">
                <h1>{timeConvert(planeado?.Total)}</h1>
            </div>
        );
    }

    function temposSemanais(representante) {
        var totalMinutos = 0;
        var planeado;
        diasDaSemanaComDatas.forEach(element => {
            planeado = temposPlaneado.find(e => element?.data.toString() == e?.data.toString() && e?.resp == representante.value);
            if (planeado != null) {
                totalMinutos = totalMinutos + Number(planeado?.Total);
            }
        });

        return (
            <div className="flex items-center justify-center font-medium dark:text-gray-400 text-gray-500">
                <h1>{timeConvert(totalMinutos)}</h1>
            </div>
        );
    }

    return (
        <>
            <div className="flex flex-row align-items justify-between" style={{justifyContent: 'space-between'}}>
                <div className="inline-flex items-center mt-2 xs:mt-0 mb-2 w-full justify-between" style={{alignItems: 'center'}}>
                    <div className="flex items-center">
                        <button
                            onClick={retrocederUmaSemana}
                            className="flex text-xs items-center justify-center px-6 h-6 font-xs border-[0.5px] border-gray-200 hover:bg-gray-100 text-blue-600 shadow-sm bg-white rounded-l dark:bg-gray-800 dark:border-gray-700 dark:text-blue-600 dark:hover:bg-blue-700 dark:hover:text-white">
                            <svg className="w-3.5 h-3.5 mr-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 5H1m0 0 4 4M1 5l4-4" />
                            </svg>
                        </button>
                        <button
                            onClick={avancarUmaSemana}
                            className="flex text-xs items-center mr-2 justify-center px-6 h-6 font-xs border-[0.5px] border-gray-200 hover:bg-gray-100 text-blue-600 shadow-sm bg-white rounded-r dark:bg-gray-800 dark:border-gray-700 dark:text-blue-600 dark:hover:bg-blue-700 dark:hover:text-white">
                            <svg className="w-3.5 h-3.5 ml-2" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M1 5h12m0 0L9 1m4 4L9 9" />
                            </svg>
                        </button>
                        {outraSemana ? (
                            <button
                                onClick={voltarParaSemanaAtual}
                                className="flex text-xs items-center border-[0.5px] rounded-[5px] justify-center px-6 h-6 font-medium font-lg shadow-sm text-blue-600 bg-white border-gray-200  mr-2 ml-2 hover:bg-gray-100 dark:bg-gray-800 dark:border-gray-700 dark:text-blue-600 dark:hover:bg-blue-700 dark:hover:text-white">
                                {t('semanaAtual')}
                            </button>
                        ) : (
                            ''
                        )}

                        <input
                            value={selectedWeek}
                            onChange={handleWeekChange}
                            type="week"
                            name="week"
                            id="camp-week"
                            className=" mr-2 text-xs px-4 h-6 border cursor-pointer border-gray-300 rounded-[5px] bg-white text-blue-600 focus:ring-blue-400 focus:border-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-blue-500 dark:focus:ring-blue-500 dark:focus:border-blue-500"
                        />
                        <label className="relative inline-flex items-center cursor-pointer">
                            <input type="checkbox" checked={fimSemana} onChange={handleToggleChange} className="sr-only peer" />
                            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-800 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
                            <span className="ml-3 text-sm font-medium text-gray-900 dark:text-gray-300">{t('fimSemana')}</span>
                        </label>
                    </div>
                    {mostraTarefa && (
                        <div className="flex justify-end ml-2 ">
                            <button
                                onClick={() => setShowFilters(!showFilters)}
                                className="text-white p-1 bg-blue-700 rounded-[8px] border border-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">
                                {t('mostrarTarefas')}
                            </button>
                        </div>
                    )}
                </div>
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
                <div className={`grid  ${showFilters ? 'grid-cols-4 gap-4' : ''} `}>
                    {' '}
                    {/* Grid separação calendario filtros */}
                    <div className={` ${showFilters ? 'col-span-3' : ''} w-full bg-[#f8f8f8] border border-gray-200 rounded-[8px] shadow dark:bg-gray-800 dark:border-gray-700`}>
                        {/* Calendário Semanal */}
                        <div className={`grid mb-2  mr-2 ${fimSemana ? 'grid-cols-15 ' : 'grid-cols-11 '}`}>
                            {/* Cabeçalho com dias da semana */}

                            {diasDaSemanaComDatas?.map((diaComData, index) => (
                                <div
                                    key={index}
                                    className={` p-2  text-center ${
                                        diaComData.dataFormata?.toUpperCase() === diadeHojeFormat?.toUpperCase()
                                            ? 'bg-blue-100 font-bold text-blue-600 dark:text-white dark:bg-blue-600'
                                            : 'dark:text-blue-400 text-blue-600 font-semibold'
                                    } ${diaComData.dataFormata != '' ? 'col-span-2' : 'col-span-1'}`}>
                                    {diaComData.dataFormata}
                                </div>
                            ))}
                            {/* Linhas Colaborador / Data */}

                            {listaRepresentantes?.map((representante, index) => {
                                const fotoUrl = representante.foto ? `data:image/png;base64,${representante.foto}` : ProfileFoto;
                                return (
                                    <>
                                        <div key={representante.value} className="col-span-1 flex flex-col items-center justify-center text-black dark:text-white" style={{alignItems: 'center'}}>
                                            {' '}
                                            {temposSemanais(representante)}
                                            <img src={fotoUrl} alt={`Foto de ${representante.label}`} className="mt-2 rounded-full h-14 w-14 drop-shadow-md" />
                                            <span className=" rounded-full p-2 ">{representante.label.slice(0, 2).toUpperCase()}</span>
                                        </div>

                                        {diasDaSemanaComDatas
                                            .filter(e => e.dataFormata != '')
                                            .map(dia => {
                                                return (
                                                    <Droppable droppableId={format(dia.data, 'yyyy-MM-dd') + 'T00:00:00' + '/' + representante.value}>
                                                        {(provided, snapshot) => (
                                                            <div ref={provided.innerRef} style={getListStyle(snapshot.isDraggingOver)} className="col-span-2 border-1 h-12 ">
                                                                {temposPlaneado.length > 0 && temposPlaneados(representante, dia)}

                                                                {reunioesVisita
                                                                    ?.filter(
                                                                        t => {
                                                                            return checkMachDay(t, dia, representante);
                                                                        },
                                                                        // e.dataF == dia && e.resp == representante.value
                                                                    )
                                                                    ?.map((reuniaoVisita, index) => {
                                                                        {
                                                                            return handleFiltroCategoria(reuniaoVisita, index);
                                                                        }
                                                                    })}
                                                            </div>
                                                        )}
                                                    </Droppable>
                                                );
                                            })}
                                    </>
                                );
                            })}
                        </div>
                    </div>
                    {showFilters && (
                        <div className=" transition-transform transform translate-x duration-300 ease-in-out">
                            <FiltrosTarefas
                                mostraFiltro={mostraFiltro}
                                nomeTarefa={nomeTarefa}
                                representantes={representantes}
                                categoriaFiltro={categoriaFiltro}
                                setCategoriaFiltro={setCategoriaFiltro}
                                representanteFiltro={representanteFiltro}
                                setRepresentanteFiltro={setRepresentanteFiltro}
                            />
                        </div>
                    )}
                </div>
            </DragDropContext>
            <div className="mt-4">
                <ReportTable />
            </div>
        </>
    );
}

export default Calendario;
